"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Difficulty = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Difficulty = function Difficulty() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-1.577 -4.5)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x2: "22",
        transform: "translate(2.077 5)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        y1: "3",
        transform: "translate(13.077 5)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        y1: "2",
        transform: "translate(13.077 15)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M19.407,19A7.407,7.407,0,0,0,12,26.407v7.407H26.815V26.407A7.407,7.407,0,0,0,19.407,19Z",
        transform: "translate(-6.288 -8.815)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "5",
        cy: "5",
        r: "5",
        transform: "translate(8.077 13)"
      })]
    })
  });
};
exports.Difficulty = Difficulty;